var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "value": _vm.dialog,
      "max-width": "600",
      "persistent": ""
    },
    on: {
      "input": _vm.closeModal
    }
  }, [_c('v-card', {
    staticClass: "card"
  }, [_c('v-card-title', {
    staticClass: "headline accent--text pb-4"
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? 'Редактировать' : 'Добавить') + " учебный период ")]), _c('v-card-text', {
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.semester,
      "item-text": "name",
      "label": "Семестр",
      "placeholder": "Выберите из списка",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "return-object": "",
      "error-messages": _vm.errorMessages.semester
    },
    on: {
      "input": function input($event) {
        return _vm.$v.submissionSession.semester.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.submissionSession.semester.$touch();
      }
    },
    model: {
      value: _vm.submissionSession.semester,
      callback: function callback($$v) {
        _vm.$set(_vm.submissionSession, "semester", $$v);
      },
      expression: "submissionSession.semester"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.dictionaries.year,
      "item-text": "name",
      "item-value": "name",
      "label": "Год",
      "placeholder": "Выберите или введите год",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "error-messages": _vm.errorMessages.year
    },
    on: {
      "keypress": _vm.keyHandler,
      "input": function input($event) {
        return _vm.$v.submissionSession.year.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.submissionSession.year.$touch();
      }
    },
    model: {
      value: _vm.submissionSession.year,
      callback: function callback($$v) {
        _vm.$set(_vm.submissionSession, "year", $$v);
      },
      expression: "submissionSession.year"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Активный период",
      "color": "success"
    },
    model: {
      value: _vm.submissionSession.isActual,
      callback: function callback($$v) {
        _vm.$set(_vm.submissionSession, "isActual", $$v);
      },
      expression: "submissionSession.isActual"
    }
  })], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "px-6"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "lightGrey"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Отмена")]), _c('v-btn', {
    attrs: {
      "loading": _vm.loading || _vm.isSaving,
      "disabled": _vm.$v.$invalid,
      "color": "success",
      "text": ""
    },
    on: {
      "click": _vm.saveSubmissionSession
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? 'Сохранить' : 'Создать') + " ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }